
export interface IRecordRow<R extends any[]>
{
	id: string,
	date?: string,
	result: R,
}

export type IResultSuperlotto638 = [
	number[],
	number,
]

export type { IResultSuperlotto638 as IResultLotto649 }

export type IResultDailyCash = [
	number[],
]
